import { render, staticRenderFns } from "./SearchTournament.vue?vue&type=template&id=bb9f88ba&scoped=true&"
import script from "./SearchTournament.vue?vue&type=script&lang=js&"
export * from "./SearchTournament.vue?vue&type=script&lang=js&"
import style0 from "./SearchTournament.vue?vue&type=style&index=0&id=bb9f88ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9f88ba",
  null
  
)

export default component.exports